import { lazy, Suspense } from "react";
import CircularLoader from "../../custom/circularLoader/circularLoader";

const Main = lazy(() => import("../../components/ErrorPage/error404"));

const ApplicationForm = () => {
    return (
      
            <Suspense fallback={<CircularLoader/>}>
                <Main/>
            </Suspense>
    )
}
export default ApplicationForm;